const DEFAULT_DATE_FORMAT = "yyyy-LL-dd";

export { DEFAULT_DATE_FORMAT };
//# sourceMappingURL=DateFormat.esm.js.map
